module.exports = __webpack_public_path__ + "img/calendar-bg_low.5e58973c.jpg";